export default function hotelsAndGroups(
  state = {
    data: null,
    isLoading: false,
    error: null
  },
  action
) {
  switch (action.type) {
    case 'GET_HOTELS_AND_GROUPS_STARTED':
      return {
        ...state,
        isLoading: true
      }

    case 'GET_HOTELS_AND_GROUPS_FAILED':
      return {
        ...state,
        error: action.payload.message,
        isLoading: false
      }

    case 'GOT_HOTELS_AND_GROUPS':
      return {
        ...state,
        isLoading: false,
        error: null,
        data: action.payload.map(g => ({
          ...g,
          key: g.id,
          subsidiaries: g.subsidiaries.map(s => ({ ...s, key: s.id }))
        }))
      }

    default:
      return state
  }
}
